import { useLoadingStore } from '@/store/useLoadingStore'
import { LoadingContentDefault } from '@/components/LoadingContentDefault'
import { useCallback } from 'react'

export const useLoading = () => {
  const setLoadingState = useLoadingStore((state) => state.setLoadingState)
  const setLoadingContent = useLoadingStore((state) => state.setLoadingContent)

  const open = useCallback(
    (content = <LoadingContentDefault />) => {
      setLoadingContent(content)
      setLoadingState(true)
    },
    [setLoadingContent, setLoadingState]
  )

  const close = useCallback(() => {
    setLoadingState(false)
  }, [setLoadingState])

  return {
    close,
    open
  }
}
